/* eslint-disable max-len */
import React from 'react';

export const AccessCodeSVG = ({
  brandSecondary,
  brandPrimary,
  brandSecondaryBackground,
  brandTint,
  brandShade1,
  brandShade2,
  brandPrimaryBackground,
}: SVGThemeProps) => (
  <svg
    width={280}
    height={216}
    viewBox="0 0 280 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Access code matched illustration"
  >
    <g clipPath="url(#clip0_2977_15634)">
      <g
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity={0.25}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.8318 149.321C70.2288 185.72 95.3778 197.677 139.321 202.818C177.774 207.317 209.968 187.434 222.527 167.889C234.764 148.846 237.954 125.14 227.231 106.946C216.655 89.0019 198.394 79.7439 158.337 77.1889C118.279 74.6344 99.3578 59.0069 83.7108 49.2524C68.0638 39.4979 41.0898 31.6124 23.7508 53.4329C6.41232 75.2539 20.9788 126.745 39.8318 149.321Z"
          fill={brandSecondary}
        />
      </g>
      <g
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity={0.25}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M127.877 130.667C141.964 150.202 162.956 164.594 199.776 158.641C233.348 153.214 261.846 121.938 262.912 74.0967C263.982 26.1157 218.62 -1.5283 199.796 3.61021C180.972 8.74921 197.643 44.6802 168.882 51.3152C140.122 57.9497 124.151 59.7277 119.361 84.5932C115.45 104.898 121.672 122.064 127.877 130.667Z"
          fill={brandPrimary}
        />
      </g>
      <g
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity={0.5}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M164.909 195.618C138.125 222.402 76.858 215.047 47.4685 185.657C18.078 156.267 26.4515 110.729 53.2355 83.9446C80.0195 57.1606 141.286 43.5446 170.676 72.9346C200.066 102.325 191.693 168.835 164.909 195.618Z"
          fill={brandSecondaryBackground}
        />
      </g>
      <g
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity={0.5}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152.153 146.609C121.725 146.609 91.1016 107.63 91.1016 74.2412C91.1016 40.8522 121.725 19.7417 152.153 19.7417C182.581 19.7417 225.117 46.8082 225.117 80.1972C225.117 113.586 182.581 146.609 152.153 146.609Z"
          fill={brandTint}
        />
      </g>
    </g>
    <g clipPath="url(#clip1_2977_15634)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.925 170.982H117.075C112.634 170.982 109 167.348 109 162.908V54.075C109 49.6335 112.634 46 117.075 46H165.925C170.367 46 174 49.6335 174 54.075V162.908C174 167.348 170.367 170.982 165.925 170.982Z"
        fill={brandShade2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.925 170.982H114.075C109.634 170.982 106 167.348 106 162.908V54.075C106 49.6335 109.634 46 114.075 46H162.925C167.367 46 171 49.6335 171 54.075V162.908C171 167.348 167.367 170.982 162.925 170.982Z"
        fill={brandPrimary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.892 158.919C111.279 158.919 110.78 158.421 110.78 157.808V61.8244C110.78 61.2114 111.279 60.7129 111.892 60.7129H165.109C165.721 60.7129 166.22 61.2114 166.22 61.8244V157.808C166.22 158.421 165.721 158.919 165.109 158.919H111.892Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.247 55.6816H146.754C147.164 55.6816 147.5 55.3461 147.5 54.9356V54.4281C147.5 54.0176 147.164 53.6816 146.754 53.6816H133.247C132.836 53.6816 132.5 54.0176 132.5 54.4281V54.9356C132.5 55.3461 132.836 55.6816 133.247 55.6816Z"
        fill={brandTint}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.247 55.6816H130.754C131.164 55.6816 131.5 55.3461 131.5 54.9356V54.4281C131.5 54.0176 131.164 53.6816 130.754 53.6816H130.247C129.836 53.6816 129.5 54.0176 129.5 54.4281V54.9356C129.5 55.3461 129.836 55.6816 130.247 55.6816Z"
        fill={brandTint}
      />
    </g>
    <g clipPath="url(#clip2_2977_15634)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.623 91.6832V103.216C121.623 113.944 128.417 123.593 139.002 128.004C149.586 123.593 156.38 113.944 156.38 103.216V91.6832C150.048 91.2907 143.991 89.0947 139.002 85.3777C134.012 89.0947 127.956 91.2907 121.623 91.6832ZM139.002 132.433L138.258 132.145C125.65 127.264 117.503 115.909 117.503 103.216V87.6267H119.563C126.247 87.6267 132.683 85.3347 137.684 81.1727L139.002 80.0757L140.32 81.1727C145.321 85.3347 151.756 87.6267 158.44 87.6267H160.5V103.216C160.5 115.909 152.354 127.264 139.745 132.145L139.002 132.433Z"
        fill={brandTint}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.001 128.004C149.586 123.594 156.38 113.945 156.38 103.216V91.6832C150.047 91.2907 143.991 89.0952 139.001 85.3777V80.0762L140.319 81.1727C145.32 85.3347 151.756 87.6267 158.44 87.6267H160.5V103.216C160.5 115.909 152.353 127.264 139.745 132.145L139.001 132.433V128.004Z"
        fill={brandPrimary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.563 89.6868C127.042 89.6868 133.84 87.0513 139.002 82.7563C144.163 87.0513 150.962 89.6868 158.44 89.6868V103.216C158.44 115.403 150.407 125.809 139.002 130.224C127.596 125.809 119.563 115.403 119.563 103.216V89.6868Z"
        fill={brandPrimaryBackground}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.002 82.7559C144.163 87.0514 150.962 89.6864 158.44 89.6864V103.216C158.44 115.402 150.408 125.808 139.002 130.224V82.7559Z"
        fill={brandSecondaryBackground}
      />
    </g>
    <g clipPath="url(#clip3_2977_15634)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M145.834 117.863H132.169C131.171 117.863 130.363 117.054 130.363 116.056V104.551C130.363 103.553 131.171 102.744 132.169 102.744H145.834C146.832 102.744 147.641 103.553 147.641 104.551V116.056C147.641 117.054 146.832 117.863 145.834 117.863Z"
        fill="#877502"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.682 100.035C134.682 97.6527 136.62 95.7147 139.002 95.7147C141.383 95.7147 143.321 97.6527 143.321 100.035V106.514H145.481V100.035C145.481 96.4562 142.58 93.5552 139.002 93.5552C135.423 93.5552 132.522 96.4562 132.522 100.035V106.514H134.682V100.035Z"
        fill={brandShade1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M145.834 117.313H132.169C131.171 117.313 130.363 116.504 130.363 115.506V104.001C130.363 103.003 131.171 102.194 132.169 102.194H145.834C146.832 102.194 147.641 103.003 147.641 104.001V115.506C147.641 116.504 146.832 117.313 145.834 117.313Z"
        fill="#ECD444"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.161 108.674C141.161 107.481 140.194 106.514 139.002 106.514C137.809 106.514 136.842 107.481 136.842 108.674C136.842 109.473 137.276 110.169 137.922 110.542V112.994H140.082V110.542C140.726 110.169 141.161 109.473 141.161 108.674Z"
        fill="#877502"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      clipPath="url(#clip4_2977_15634)"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M276 108.111C276 107.007 276.895 106.111 278 106.111C279.105 106.111 280 107.007 280 108.111C280 109.216 279.105 110.111 278 110.111C276.895 110.111 276 109.216 276 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M258 108.111C258 106.455 259.344 105.111 261 105.111C262.656 105.111 264 106.455 264 108.111C264 109.768 262.656 111.111 261 111.111C259.344 111.111 258 109.768 258 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M238 108.111C238 105.902 239.791 104.111 242 104.111C244.209 104.111 246 105.902 246 108.111C246 110.32 244.209 112.111 242 112.111C239.791 112.111 238 110.32 238 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214 108.111C214 104.797 216.687 102.111 220 102.111C223.313 102.111 226 104.797 226 108.111C226 111.425 223.313 114.111 220 114.111C216.687 114.111 214 111.425 214 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186 108.111C186 103.693 189.582 100.111 194 100.111C198.418 100.111 202 103.693 202 108.111C202 112.529 198.418 116.111 194 116.111C189.582 116.111 186 112.529 186 108.111Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      clipPath="url(#clip5_2977_15634)"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 108.111C4 109.216 3.1045 110.111 2 110.111C0.8955 110.111 0 109.216 0 108.111C0 107.007 0.8955 106.111 2 106.111C3.1045 106.111 4 107.007 4 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 108.111C22 109.768 20.6565 111.111 19 111.111C17.3435 111.111 16 109.768 16 108.111C16 106.455 17.3435 105.111 19 105.111C20.6565 105.111 22 106.455 22 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42 108.111C42 110.32 40.209 112.111 38 112.111C35.791 112.111 34 110.32 34 108.111C34 105.902 35.791 104.111 38 104.111C40.209 104.111 42 105.902 42 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66 108.111C66 111.425 63.3135 114.111 60 114.111C56.6865 114.111 54 111.425 54 108.111C54 104.797 56.6865 102.111 60 102.111C63.3135 102.111 66 104.797 66 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94 108.111C94 112.529 90.4185 116.111 86 116.111C81.5815 116.111 78 112.529 78 108.111C78 103.693 81.5815 100.111 86 100.111C90.4185 100.111 94 103.693 94 108.111Z"
        fill={brandSecondary}
      />
    </g>
    <defs>
      <clipPath id="clip0_2977_15634">
        <rect width={246.931} height={209.398} fill="white" transform="translate(16 3)" />
      </clipPath>
      <clipPath id="clip1_2977_15634">
        <rect width={68} height={125} fill="white" transform="translate(106 46)" />
      </clipPath>
      <clipPath id="clip2_2977_15634">
        <rect width={43} height={53} fill="white" transform="translate(117.503 80.0757)" />
      </clipPath>
      <clipPath id="clip3_2977_15634">
        <rect width={18} height={25} fill="white" transform="translate(130.363 93.5552)" />
      </clipPath>
      <clipPath id="clip4_2977_15634">
        <rect width={94} height={17} fill="white" transform="translate(186 100)" />
      </clipPath>
      <clipPath id="clip5_2977_15634">
        <rect width={94} height={17} fill="white" transform="translate(0 100)" />
      </clipPath>
    </defs>
  </svg>
);
